// extracted by mini-css-extract-plugin
export default {"content":"styles_content__OJxh1","block":"styles_block__03MYn"};